import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import roomTypePagesRoleManagement from '../../staticRoleManagement/roomTypeRoleManagement'
import useStyles from './styles/RoomtypeFooter.styles'

interface RoomtypeFooterProps {
  isSubmitting: boolean
  loadingForRoomType: boolean
}

export const RoomtypeFooter: React.FC<RoomtypeFooterProps> = ({
  isSubmitting,
  loadingForRoomType
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const hasAccessToWriteRoomTypeDetails = roomTypePagesRoleManagement
    .find(
      (item) =>
        item.route ===
        '/accommodations/:accommodationID/:propertyCode/room-types/:roomTypeId/:roomTypeCode/:page'
    )
    ?.tabs?.find((tabItem) => tabItem.params.page === 'details')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.footer}>
      <Button
        disabled={isSubmitting || !hasAccessToWriteRoomTypeDetails}
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        fullWidth={matches}>
        {getTranslate('Save Room Type')}
        {loadingForRoomType && (
          <CircularProgress className={classes.circularProgress} size={16} />
        )}
      </Button>
    </div>
  )
}
